const MAX_RETRY = 1;
const RETRY_WINDOW_MS = 5 * 60 * 1000; // 5 minutes

const now = () => Date.now();

const getStorageKey = (userId) => `demande_retry_${userId}`;

const getData = (userId) => {
  const raw = localStorage.getItem(getStorageKey(userId));
  if (!raw) return null;

  const data = JSON.parse(raw);

  // 🔁 reset auto after 2 hours
  if (now() - data.startedAt > RETRY_WINDOW_MS) {
    localStorage.removeItem(getStorageKey(userId));
    return null;
  }

  return data;
};

export const canRetry = (userId) => {
  const data = getData(userId);
  return !data || data.count < MAX_RETRY;
};

export const registerFailure = (userId) => {
  const data = getData(userId);

  if (!data) {
    const newData = {
      startedAt: now(),
      count: 1,
      technicalReported: false
    };
    localStorage.setItem(
      getStorageKey(userId),
      JSON.stringify(newData)
    );
    return newData;
  }

  const newData = {
    ...data,
    count: data.count + 1
  };

  localStorage.setItem(
    getStorageKey(userId),
    JSON.stringify(newData)
  );
  return newData;
};

export const shouldReportTechnicalError = (userId) => {
  const data = getData(userId);
  return data && data.count >= MAX_RETRY && !data.technicalReported;
};

export const markTechnicalReported = (userId) => {
  const data = getData(userId);
  if (!data) return;

  localStorage.setItem(
    getStorageKey(userId),
    JSON.stringify({
      ...data,
      technicalReported: true
    })
  );
};

export const resetRetry = (userId) => {
  localStorage.removeItem(getStorageKey(userId));
};

export async function callWithRetryGuard(userId, requestFn) {
  if (!canRetry(userId)) {
    throw new Error("RETRY_LIMIT_REACHED");
  }

  try {
    return await requestFn();
  } catch (err) {
    registerFailure(userId);
    throw err;
  }
}